import type { ShopContent } from '../../../types';
import type { MediaItem } from './format';
import type { Review } from './types';
import { toMediaItems, toReview } from './adapters';

/**
 * Vad blocken Omdömen och Bildrulle i Studio visar, ur Butikens innehåll:
 * bara publicerade omdömen, och med featuredOnly bara de utvalda. Bildrullen
 * visar bilderna från omdömena och kundbilderna utan omdöme.
 */
export const reviewsForSection = (content: ShopContent, featuredOnly = false): Review[] =>
    content.reviews.filter(r => r.published && (!featuredOnly || r.featured)).map(toReview);

export const mediaForSection = (content: ShopContent, featuredOnly = false): { reviews: Review[]; extra: MediaItem[] } => ({
    reviews: reviewsForSection(content, featuredOnly),
    extra: toMediaItems(content.media),
});
